import { Card, Tag } from 'antd';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ChannelContext } from "../../../context/channel";
import colors from '../../../theme/colors';
import TimeIcon from '../../shared/Icons/TimeIcon';


interface StyledThumbProps {
  style?: any;
  color: string;
  state?: string;
  colorTooLight?:boolean;
}

interface IWebnarTitle {
  colorHover: string;
}

export type ThumbObject = {
  cover?: string,
  title: string,
  date: string,
};

export interface IThumb {
  object: ThumbObject;
  style?: any;
  color: string;
  onClick?: (obj: ThumbObject) => void;
  showTag?: boolean;
  state?: string;
}

const DEFAULT_COLOR = 'primary';

const getImage = (image: any) => {
  if (!image) throw new Error(`Invalid image`);
  return image;
};

const StyledThumb = styled.div<StyledThumbProps>`
  text-align: center;
  background-color: transparent;

  .image-cover {
    height: 100%;
  }

  .cardCover{
    position: relative;
    height: 208px;
    width: 288px;

    ${(props) => props.theme?.mediaQuerie.maxWidth.sm}{
      width: 230px;
      height: 166px;
    }

    >div{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(180deg, ${(props) => props.color}00 0%, ${(props) => props.color}99 100%);
      opacity: 0;

      &:hover{
        opacity: 1;
        transition: .5s;
      }
    }

    .tag-state{
      position: absolute;
      top: 4px;
      left: 4px;
      font-weight: 700;
      color: ${(props) => props.state === 'Live' ? props.theme.colors.white : props.theme.colors.black};
      border-radius: 16px;
    }

    img{
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  .ant-card-body{
      padding: 15px 15px 15px 0 ;
      text-align: left;
  }

    .ant-card:hover{
        .cardCover{
          >div{
            opacity: 1;
            transition: .5s;
          }
        }
        .eventials-typography:first-child{
          color: ${(props) => props.colorTooLight ? props.theme.colors.body : props.color} !important;
       }
    }

  .dateContainer {
    display: flex;
  }
`;

const WebnarTitle = styled.span<IWebnarTitle>`
 font-weight: 500;
 :hover {
   color: ${(props) => props.colorHover}
 }
`;
const DateAndHour = styled.span`
  margin-top: '8px';
  color: "label";

  @media only screen and (max-width: 500px){
    font-size: 12px;
  }
`;

export const DEFAULT_THUMB_IMAGE =
  'https://static.eventials.com/static/images/talk_thumb.svg';


const Thumb = ({ object, style, color, onClick, showTag, state }: IThumb) => {
  const {data} = React.useContext(ChannelContext)

  const [colorTooLight, setColorTooLight] = useState<boolean>(false);

  useEffect(() => {
    function lightOrDark(color:string){
      const hex = color.replace('#', '');
      const c_r = parseInt(hex.substr(0, 2), 16);
      const c_g = parseInt(hex.substr(2, 2), 16);
      const c_b = parseInt(hex.substr(4, 2), 16);
      const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
      return brightness > 155;
    }

    let colorString = color
    let brightness = lightOrDark(colorString)
    setColorTooLight(brightness)
  }, [color]);

  return (
    <StyledThumb color={color} style={{ ...style }} state={state} colorTooLight={colorTooLight}>
      <Card
        data-testid="thumb-card"
        style={{
          width: '100%',
          backgroundColor: 'transparent',
          border: 'none',
          borderRadius: '8px',
          padding: 0,
        }}
        cover={
          <div className="cardCover">
            <div className="backgroundGradient" />
            {showTag && 
              <Tag className="tag-state" color={state === 'Live' ? colors.primary : colors.white}>
                {state}
              </Tag>
            }
            <img src={getImage(object.cover ? object.cover : DEFAULT_THUMB_IMAGE)} alt="thumb" className="image-cover"/>
          </div>
        }
        onClick={() => (onClick ? onClick(object) : null)}
        className="card"
      >
        <WebnarTitle colorHover={data.config.colors?.colorPrimary}>
          {object.title}
        </WebnarTitle>
        <br />
        <div className="dateContainer">
          <TimeIcon fill={state === "recorded" ? data.config.colors.colorPrimary : colors.primary} style={{marginRight: '5px'}}/>
          <DateAndHour>
            {object.date.split("às")[0] + " " + t('date.at') + " " + object.date.split("às")[1]}
          </DateAndHour>
        </div>
      </Card>
    </StyledThumb>
  );
};

Thumb.defaultProps = {
  onClick: () => {},
  color: DEFAULT_COLOR,
};

export default Thumb;
